module.exports = __webpack_public_path__ + "img/defaultup.15359c1b.svg";